import {
	FontIconName,
	Icon,
	IconValue,
	isSvgIcon,
	SvgIconValue
} from "../../Icon/Icon";
import { ReactElement, useMemo } from "react";

export type ActionBarButtonIconProps = {
	icon?: FontIconName | SvgIconValue;
	isDisabled?: boolean;
};

export const ActionBarButtonIcon = (props: ActionBarButtonIconProps): ReactElement | null => {
	const {
		icon,
		isDisabled = false
	} = props;

	const iconProps: IconValue | null = useMemo(
		() => {
			if (!icon) {
				return null;
			}

			if (isSvgIcon(icon)) {
				return icon;
			}

			return {
				kind: "font",
				name: icon,
				color: isDisabled
					? undefined
					: "primary"
			};
		},
		[icon, isDisabled]
	);

	if (!iconProps) {
		return null;
	}

	return <Icon value={iconProps} />;
};

ActionBarButtonIcon.displayName = "ActionBarButtonIcon";
